"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var getHelpfulLinks = function (subdomain) {
    return (0, service_1.getService)()
        .get('/support/links', { params: { subdomain: subdomain } })
        .then(function (_a) {
        var data = _a.data;
        return data === null || data === void 0 ? void 0 : data.data;
    });
};
exports.default = getHelpfulLinks;
